module.exports = __webpack_public_path__ + "static/media/logo.39ab2ba6.png";